import { OutlinedButton } from "@components/atoms/base-button";
import type { MouseEventHandler } from "react";
import { translate } from "@locales";

interface NoResultFilterProps {
  onClickHandler: MouseEventHandler;
}

export function NoResultFilter({ onClickHandler }: NoResultFilterProps) {
  return (
    <div className="flex flex-col items-center gap-y-[15px]">
      <span className="text-[25px] text-dark-gray">
        {translate("shop.filter.no-match.0")}
      </span>
      <span className="text-sm">{translate("shop.filter.no-match.1")}</span>
      <OutlinedButton className="uppercase w-[200px]" onClick={onClickHandler}>
        {translate("shop.filter.no-match.button")}
      </OutlinedButton>
    </div>
  );
}
